<template>
    <b-modal v-if="isOutputTransactionModalOpen" v-model="isOutputTransactionModalOpen" size="xl" no-close-on-backdrop no-close-on-esc>
        <template #modal-header style="padding: 0; margin: 0;" class="pb-0">
            <b-row class="w-100 pb-1">
                <div v-if="output_transaction.general.id == null">
                    <b-col align-h="start">
                        <h2>Novo Pagamento</h2>
                    </b-col>

                    <b-col align-h="start">
                        <div style="color: black;">
                            Digite as informações solicitadas para adicionar um novo pagamento.
                        </div>
                    </b-col>
                </div>

                <div v-else>
                    <b-col align-h="start">
                        <h2>Pagamento #<b>{{ output_transaction.general.id }}</b></h2>
                    </b-col>
                </div>
            </b-row>
        </template>

        <output-transaction-form @emitDisabledSaveButton="handleDisabledSaveButton"></output-transaction-form>

        <template #modal-footer>
            <div class="w-100">
                <div class="modal-add-footer">
                    <div class="d-flex w-100">
                        <div @click.prevent="confirmDelete"  :disabled="closedTransaction" :class="`btn btn-outline-danger btn-sm  ${closedTransaction?'disabled':''}`">
                            <i class="fas fa-trash fa-lg ml-2 mr-2 mt-2 mb-2" style="font-size: 1.5rem;"></i>
                        </div>
                        <div @click.prevent="closeTransactionModal()" class="btn btn-outline-danger w-100" style="padding-top: 9px;">CANCELAR</div>
                        <div @click.prevent="saveTransaction()" :disabled="disabledSaveButton" :class="`btn btn-back w-100 ${disabledSaveButton ? 'disabled' : ''}`" style="padding-top: 9px;">
                            SALVAR
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import OutputTransactionForm from './OutputTransactionForm.vue';
import { mapActions, mapGetters } from 'vuex';
import swal from "sweetalert2"

export default {
    name: 'OutputTransactionModal',

    components: {
        OutputTransactionForm,
    },

    props: {
        isOutputTransactionModalOpen: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('financeiro', {
            output_transaction: 'getOutputTransaction',
        }),

        ...mapGetters('auth', {
            place: 'getPlace'
        }),

    closedTransaction() {
      return !this.output_transaction.general.open
    },

    },

    watch: {
    },

    data() {
        return {
            disabledSaveButton: false,
        }
    },

    methods: {
        ...mapActions('product', [
            'fetchPOIs',
        ]),

        ...mapActions('financeiro', [
            'createTransaction',
            'deleteTransaction',
        ]),

        async saveTransaction() {
            if (!this.disabledSaveButton) {
                let validatedForm = true

                if (!this.output_transaction.payment.date) {
                    this.$notify({ message: `Selecione a data de pagamento!`, duration: 3000, type: 'error' })
                    validatedForm = false
                    return
                }

                if (!this.output_transaction.general.date) {
                    this.$notify({ message: `Selecione a data do pagamento!`, duration: 3000, type: 'error' })
                    validatedForm = false
                    return
                }

                if (this.output_transaction.general.label.length == 0) {
                    this.$notify({ message: `Digite o rótulo do pagamento!`, duration: 3000, type: 'error' })
                    validatedForm = false
                    return
                }

                if (!validatedForm) {
                    return
                }

                this.output_transaction.type = 0

                await this.createTransaction(this.output_transaction)
                    .then(() => {
                        let message = "Saída financeira atualizada!"
                        if (this.output_transaction.general.id == null) {
                            message = "Saída financeira criada!"
                        }

                        this.$notify({ title: this.output_transaction.general.label, message: message, duration: 6000, type: "success" })
                        this.closeTransactionModal()
                        this.$parent.$emit("loadTransactions")
                    })
                    .catch((err) => {
                    })
            }
        },

        handleDisabledSaveButton(value) { this.disabledSaveButton = value },

        closeTransactionModal() { this.$emit('closeOutputTransactionModal', false) },

        confirmDelete() {
            swal.fire({
                title: `Deseja excluir o pagamento #${this.output_transaction.general.id} ?`,
                text: `Pagamento ${this.output_transaction.general.label}`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, excluir',
                confirmButtonColor: '#D93051',
                cancelButtonText: 'Não',
                reverseButtons: true,
                cancelButtonColor: 'secondary',
                // type: 'default'
            })
                .then((async result => {
                    if (result.isConfirmed) {
                        this.output_transaction.type = '0'

                        await this.deleteTransaction(this.output_transaction)
                        this.closeTransactionModal()
                        this.$notify({ title: "Pagamento #" + this.output_transaction.general.id + " :: " + this.output_transaction.general.label, message: "Pagamento excluído!", duration: 6000, type: "success" })
                        setTimeout(() => {
                            this.$parent.$emit("loadTransactions")
                        }, 50)
                    }
                }))
        },

    },

    async mounted() {
        const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
        await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: "" })
    },

}
</script>

<style>
.modal-add-footer {
    display: flex;
}

/* .progress-bar {
        background-color: #D9D9D9;
        width: auto;
        height: 10px;
        border-radius: 10px;
        margin-bottom: 15px;
   } */

.progress-bar-inside {
    background-color: #A7AA37;
    width: auto;
    height: 10px;
    border-radius: 10px;
}

.switch-wrapper {
    display: flex;
    align-items: center;
}

.switch-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
}

.switch {
    width: 40px;
    height: 20px;
    position: relative;
    appearance: none;
    background: #ccc;
    border-radius: 20px;
    outline: none;
    cursor: pointer;
    transition: background 0.3s;
}

.switch:checked {
    background: #22a06b;
}

.switch:before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    background: white;
    border-radius: 50%;
    top: 1px;
    left: 2px;
    transition: 0.3s;
}

.switch:checked:before {
    left: 20px;
}

.status-label {
    margin-left: 10px;
    font-weight: 600;
    color: #1b1b1b;
}

.button-habilitar {
    display: none;
}
</style>
